import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userInitials'
})
export class UserInitialsPipe implements PipeTransform {
  transform(username: string): string {
    if (!username) return '';

    // Split the username into words and filter out empty strings
    const words = username.split(' ').filter(word => word.length > 0);
    
    // If no valid words, return empty string
    if (words.length === 0) return '';

    // If single word, return just its first letter
    if (words.length === 1) {
      return words[0][0].toUpperCase();
    }

    // For multiple words, return first letter of first word + first letter of last word
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }
} 